import script from "./DesktopViewport.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopViewport.vue?vue&type=script&setup=true&lang=js"

import "./DesktopViewport.vue?vue&type=style&index=0&id=0d468144&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d468144"]])

export default __exports__